<template>
    <div>
        <form @submit.prevent="validateBeforeSubmit" class="mb-2">
            <div :class="['form-group', {'is-invalid': $v.loginData.email.$error}]">
                <input
                        :class="{ 'is-invalid': $v.loginData.email.$error }"
                        v-model.trim="loginData.email"
                        class="form-control"
                        placeholder="Введите Email..."
                        type="email"
                        @input="$v.loginData.email.$touch()">
                <span v-if="!$v.loginData.email.required" class="invalid-feedback">
        Требуется ввести Email
      </span>
                <span v-if="!$v.loginData.email.email" class="invalid-feedback">
        Некорректный Email
      </span>
            </div>
            <div :class="['form-group', {'is-invalid': $v.loginData.password.$error}]">
                <input
                        :class="{ 'is-invalid': $v.loginData.password.$error }"
                        v-model.trim="loginData.password"
                        class="form-control"
                        placeholder="Введите пароль..."
                        type="password"
                        @input="$v.loginData.password.$touch()">
                <span v-if="!$v.loginData.password.required" class="invalid-feedback">
        Требуется ввести пароль
      </span>
                <span v-if="!$v.loginData.password.minLength" class="invalid-feedback">
        Пароль должен быть не менее {{ $v.loginData.password.$params.minLength.min }} символов.
      </span>
            </div>
            <div class="other-actions row">
                <!--<div class="col-sm-6">-->
                <!--<div class="checkbox">-->
                <!--<label class="c-input c-checkbox">-->
                <!--<input-->
                <!--v-model="loginData.remember"-->
                <!--type="checkbox"-->
                <!--name="remember">-->
                <!--<span class="c-indicator"/>-->
                <!--Remember Me-->
                <!--</label>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="col-sm-6 text-sm-right">-->
                <!--<a href="#" class="forgot-link">-->
                <!--Forgot Password?-->
                <!--</a>-->
                <!--</div>-->
            </div>
            <button class="btn btn-theme btn-full" style="background-color: #204694; border-color: #204694;">Войти</button>
        </form>
        <!--<div class="mb-2 mt-2">Войти с помощью</div>-->
        <a href="/google-auth" class="mt-2">
            <button class="btn btn-theme btn-full" style="background-color: #204694; border-color: #204694;">
                Войти с помощью Google
                <!--<i class="icon-fa icon-fa-google"></i>-->
            </button>
        </a>
    </div>
</template>

<script type="text/babel">
    import {required, minLength, email} from 'vuelidate/lib/validators'
    import Auth from '../../services/auth'

    export default {
        data() {
            return {
                loginData: {
                    email: '',
                    password: '',
                    remember: ''
                }
            }
        },
        validations: {
            loginData: {
                password: {
                    required,
                    minLength: minLength(6)
                },
                email: {
                    required,
                    email
                }
            }
        },
        methods: {
            validateBeforeSubmit() {
                this.$v.$touch()

                if (!this.$v.$error) {
                    Auth.login(this.loginData).then((res) => {
                        if (res) {
                            Auth.getCurrentUser()
                                .then(function (response) {
                                    Vue.prototype.$currentUser = response.user;
                                    this.$router.push('/')
                                }.bind(this))
                        }
                    })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/auth/Login.vue